var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscountIcon = function SvgDiscountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    fill: "none",
    viewBox: "0 0 28 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_4935)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.51.655H2.508A2.467 2.467 0 00.044 3.12v15.797a2.466 2.466 0 002.464 2.465H25.51a2.466 2.466 0 002.464-2.465V3.12A2.466 2.466 0 0025.51.655zM2.508 2.298H25.51c.452 0 .821.37.821.822v3.565H1.687V3.12c0-.452.37-.822.821-.822zm23.002 17.44H2.508a.824.824 0 01-.821-.822V8.327h24.644v10.59c0 .451-.37.82-.821.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.222 15.048a1.778 1.778 0 110 3.555 1.778 1.778 0 010-3.555zm1.648-4.315c.16.16.172.413.037.587l-.037.042-7.111 7.111a.445.445 0 01-.666-.587l.037-.042 7.111-7.11a.445.445 0 01.629 0zm-1.648 5.204a.889.889 0 100 1.777.889.889 0 000-1.777zm-4.444-5.334a1.778 1.778 0 110 3.556 1.778 1.778 0 010-3.556zm0 .889a.889.889 0 100 1.778.889.889 0 000-1.778z",
    clipPath: "url(#clip1_411_4935)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_4935"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v20.794H0z",
    transform: "translate(0 .603)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_411_4935"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8v8H0z",
    transform: "translate(17 10.603)"
  })))));
};
export default SvgDiscountIcon;